module.exports = __webpack_public_path__ + "static/media/吾股排名@2x.6468f384.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/吾股排名@2x.png
// module id = 1566
// module chunks = 0